import { Injectable } from '@angular/core';

export interface EdiWrapperTile {
  routerLink: string;
  title: string;
  description: string;
}

@Injectable({
  providedIn: 'root'
})
export class EdiWrapperTilesService {
  getExtraTiles(): EdiWrapperTile[] {
    return [];
  }
}
